import { useQuery } from '@tanstack/react-query'

import { getInvoice } from './api'
import { invoiceDetailKey } from './keys'

export function useInvoice(id: string) {
  return useQuery({
    queryKey: invoiceDetailKey(id),
    queryFn: ({ signal }) => getInvoice(id, signal),
    enabled: Boolean(id)
  })
}
